"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experimental__simple = void 0;
const createTheme_1 = require("../createTheme");
exports.experimental__simple = (0, createTheme_1.experimental_createTheme)({
    //@ts-expect-error not public api
    simpleStyles: true,
});
